// @flow
import * as React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';
import { noop } from 'lodash';
import * as cssUtils from 'app/utils/cssUtils';
import Tappable from 'app/components/commons/Tappable';
import Icon from 'app/components/commons/Icon';

type Props = {
  classes: Object,
  channel: {
    id: number | string,
    name: string,
    icon: string,
    slug?: string
  },
  isActive?: boolean,
  onChannelClick?: (channel: Object) => void
};

const defaultProps = {
  isActive: false,
  onChannelClick: noop
};

function ChannelItem({ classes, channel, isActive, onChannelClick }: Props) {
  return (
    <Tappable
      component="div"
      className={classNames(classes.channel, { active: isActive })}
      onTap={() => onChannelClick(channel.id)}
    >
      <Icon className={classes.channelIcon} type={channel.icon} />
      <span>{channel.name}</span>
    </Tappable>
  );
}

ChannelItem.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    channel: {
      height: 50,
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing.small,
      flexBasis: '25%',
      transition: 'color 0.2s',
      fontSize: 12,
      textTransform: 'uppercase',
      color: theme.color.basis5,
      ...cssUtils.hover({
        color: theme.color.basis3
      }),
      '&.active': {
        color: theme.color.basis3
      }
    },
    channelIcon: {
      fontSize: 18,
      marginRight: 5
    }
  };
}

export default useSheet(applyStyles)(ChannelItem);
